import { makeStyles } from '@material-ui/core';

export const useNewDownloadAppStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    padding: theme.spacing(1, 2),
    backgroundColor: theme.colors.cmp.Card.Primary.active.background,
    color: theme.colors.cmp.Card.Primary.active.text,
  },
  texts: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(14),
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    margin: theme.spacing(1, 0),
  },
}));
